export default __webpack_public_path__ + "static/media/parceiro.b01a35eb.svg";